export default "__VITE_PUBLIC_ASSET__583443ac__"